var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLivingroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 82,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M81.315 65.2677V6.4917c0-3.131 2.549-5.669 5.695-5.669h52.562c3.145 0 5.694 2.538 5.695 5.669l.003 58.767"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M81.315 65.2677V6.4917c0-3.131 2.549-5.669 5.695-5.669h52.562c3.145 0 5.694 2.538 5.695 5.669l.003 58.767"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M81.2803 65.2677V6.4917c0-3.131-2.549-5.669-5.695-5.669h-52.591c-3.145 0-5.694 2.538-5.694 5.669v58.776"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M81.2803 65.2677V6.4917c0-3.131-2.549-5.669-5.695-5.669h-52.591c-3.145 0-5.694 2.538-5.694 5.669v58.776"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M157.2637 36.8708c0-6.624-5.37-11.994-11.994-11.994s-11.994 5.37-11.994 11.994 5.37 11.994 11.994 11.994 11.994-5.37 11.994-11.994"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M157.2637 36.8708c0-6.624-5.37-11.994-11.994-11.994s-11.994 5.37-11.994 11.994 5.37 11.994 11.994 11.994 11.994-5.37 11.994-11.994z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29.2935 36.8708c0-6.624-5.37-11.994-11.994-11.994s-11.994 5.37-11.994 11.994 5.37 11.994 11.994 11.994 11.994-5.37 11.994-11.994"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M29.2935 36.8708c0-6.624-5.37-11.994-11.994-11.994s-11.994 5.37-11.994 11.994 5.37 11.994 11.994 11.994 11.994-5.37 11.994-11.994z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M129.313 76.8766v-11.977h-8.007v11.991h.008c0 2.209 1.791 4 4 4s3.999-1.791 3.999-4v-.014"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M129.313 76.8766v-11.977h-8.007v11.991h.008c0 2.209 1.791 4 4 4s3.999-1.791 3.999-4v-.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M41.3072 76.8766v-11.977h-8.007v11.991h.008c0 2.209 1.791 4 4 4s4-1.791 4-4c0-.005-.001-.009-.001-.014"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M41.3072 76.8766v-11.977h-8.007v11.991h.008c0 2.209 1.791 4 4 4s4-1.791 4-4c0-.005-.001-.009-.001-.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M158.4268 64.8239H4.1348c-1.566 0-2.835-1.269-2.835-2.834v-10.31c0-1.565 1.269-2.835 2.835-2.835h154.292c1.565 0 2.834 1.27 2.834 2.835v10.31c0 1.565-1.269 2.834-2.834 2.834"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M158.4268 64.8239H4.1348c-1.566 0-2.835-1.269-2.835-2.834v-10.31c0-1.565 1.269-2.835 2.835-2.835h154.292c1.565 0 2.834 1.27 2.834 2.835v10.31c0 1.565-1.269 2.834-2.834 2.834z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingroom);
export default __webpack_public_path__ + "static/media/livingroom.0ab80afbd97318df5879f89b479cf772.svg";
export { ForwardRef as ReactComponent };